import React, { useContext } from 'react';
import styled from 'styled-components';
import Legend from './Legend';
import Gallery from './Gallery';
import { breakpoints } from '../styles/Variables';
import soldOutImage from '../assets/images/sold-out.svg';
import { tr } from '../utils/translations';
import LocaleContext from './LocaleContext';

const HideawayStyles = styled.div`
  width: 100%;
  padding-bottom: 2rem;
  max-width: var(--maxPageWidth);
  margin-left: auto;
  margin-right: auto;

  h3 {
    text-align: center;
    font-size: var(--fsTitle2);
    margin-bottom: 2rem;
  }

  .legends {
    padding: 0 var(--col1);

    .legend {
      p {
        text-align: left;
      }

      .block {
        margin-bottom: 0;
      }

      .title {
        border-bottom: 1px solid var(--black);
        padding-bottom: 0.5rem;
        margin-bottom: 0.5rem;
        display: block;
        text-align: left;
      }

      &.overview {
        width: 100%;
        margin-bottom: 2rem;
      }

      &.size,
      &.levels {
        display: inline-block;
        width: 50%;

        @media (min-width: ${breakpoints.breakLg}) {
          display: block;
          width: 100%;
        }
      }
    }
  }

  &.soldOut {
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      background: transparent url(${soldOutImage}) no-repeat center;
      width: 100%;
      height: 66vw;
      background-size: 20vw;

      @media (min-width: ${breakpoints.breakLg}) {
        height: 33vw;
        width: calc(var(--col7) - 3rem);
        left: var(--col1Internal);
        background-size: 12vw;
      }
    }
  }

  @media (min-width: ${breakpoints.breakLg}) {
    display: grid;
    grid-template-columns: var(--col8) var(--col4);
    grid-gap: 2rem;
    padding: 0 var(--col1);
    padding-bottom: 4rem;

    h3 {
      text-align: left;
    }

    .gallery {
      .slick-slide {
        height: 33vw;
      }
    }
  }
`;

export default function Hideaway({
  name,
  gallery,
  legends,
  imageMaxWidth,
  className,
}) {
  const [locale] = useContext(LocaleContext);

  const emailSubject = `Enquiry%20about%20Hideaway%20H${name}`;
  const emailBody = `What%20is%20your%20name?%0D%0A%0D%0AWhat%20would%20you%20like%20to%20learn%20more%20about?%0D%0A%0D%0AAre%20you%20looking%20to%20buy%20on%20your%20own%20or%20with%20other%20parties?`;

  return (
    <HideawayStyles className={`hideaway ${className}`}>
      {gallery && (
        <Gallery
          images={gallery.images}
          imageMaxWidth={imageMaxWidth}
          className={`gallery ${gallery.className}`}
        />
      )}
      <div className="legends">
        <h3>
          {tr('titles', 'model', locale)} H{name}
        </h3>
        {legends &&
          legends.map((legend) => (
            <Legend
              key={legend._key}
              name={legend.name}
              text={legend.text}
              className={legend.className}
            />
          ))}
        <div className="buttonWrapper">
          <a
            className="button"
            href={`mailto:tara@findmusa.mx?cc=marketing@findmusa.mx&subject=${emailSubject}&body=${emailBody}`}
          >
            {tr('cta', 'enquireAboutThisProperty', locale)}
          </a>
        </div>
      </div>
    </HideawayStyles>
  );
}
